<template>
    <!-- DESCR：主席查看会议所投稿的页面 -->
    <div class="viewpaper-box">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">{{ $route.query.acronym }} List of Submissions</div>
                    <br />
                    <div class="info">
                        The current role is the chairman, where you can see all submitted paper information
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <!-- 会议投稿论文列表 -->
        <div class="paperlist-box">
            <div class="click-tips">
                <span class="text-line">Red indicates that the submitted content lacks mandatory documents
                </span>
                <div class="tools-box">
                    <div class="tools-left">
                        <el-tag style="cursor: pointer;margin-right: 10px;" @click="authoremail"
                            v-show="checkPermission([`${$route.query.cid}.publish`])">Email to Authors</el-tag>
                        <el-tag style="cursor: pointer;margin-right: 10px;" @click="emailManagement"
                            v-show="checkPermission([`${$route.query.cid}.publish`])">Email Management</el-tag>
                        <el-tag style="cursor: pointer;margin-right: 10px;" @click="outPaper"
                            v-show="checkPermission([`${$route.query.cid}.publish`])">Download submissions</el-tag>
                        <el-tag style="cursor: pointer;margin-right: 10px;" @click="paperDelete"
                            v-show="checkPermission([`${$route.query.cid}.publish`])">Delete
                            submission(s)</el-tag>
                    </div>
                    <div class="tools-left">
                        <el-tag style="cursor: pointer;margin-right: 10px;" @click="paperStatus" type="warning"
                            v-show="checkPermission([`${$route.query.cid}.publish`])">Status</el-tag>
                        <el-tag style="cursor: pointer;margin-right: 10px;" @click="confdesc" type="warning">Conference
                            Desc</el-tag>
                    </div>
                </div>
            </div>
            <el-table :data="conferencePaperList" style="width: 100%" border @sort-change="sortTable" class="tb-box"
                height="486px">
                <template #empty>
                    <el-empty description="Data is loading..." />
                </template>
                <el-table-column label="Id" width="100" align="center" sortable="custom" header-align="center">
                    <template #default="scope">
                        <span>{{ scope.row.autoid }}</span>
                    </template>
                </el-table-column>
                <el-table-column width="280" label="Authors" align="left" header-align="center">
                    <template #default="scope">
                        <el-text class="author-text">{{ scope.row.authors }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="Title" align="left" header-align="center">
                    <template #default="scope">
                        <el-text class="title-text">{{ scope.row.title }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="Affiliation" align="left" width="400" header-align="center">
                    <template #default="scope">
                        <div class="affiliation-text">
                            <div v-for="(aff, index) in scope.row.affiliation" :key="index">
                                <el-text class="title-text" v-if="aff">{{ aff }}</el-text>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="UpdateTime" align="left" width="160" sortable="custom" header-align="center">
                    <template #default="scope">
                        <el-text class="title-text">{{ scope.row.updatetime }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="Operate" width="350" align="center">
                    <template #header>
                        <el-input v-model="searchValue" size="small" placeholder="enter search content"
                            @input="changeSearchValue" :suffix-icon="Search" />
                    </template>
                    <template #default="scope">
                        <el-button size="small" @click="look(scope.$index, scope.row)" type="danger"
                            :icon="View">information</el-button>
                        <el-button size="small" @click="download(scope.$index, scope.row)" type="danger"
                            :icon="Document">paper</el-button>
                        <el-button size="small" @click="send(scope.$index, scope.row)" type="danger"
                            :disabled="scope.row.isTermination == 1" :icon="Position">assignment</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-tools">
            <el-pagination small background layout="total,prev, pager, next, jumper"
                :total="parseInt(conferencePage.total)" :page-size="parseInt(conferencePage.pagesize)"
                @current-change="changePage" hide-on-single-page />
        </div>

        <!-- 隐藏层:进行推送论文 -->
        <el-dialog title="Select reviewers" v-model="diadetails" width="50%" center>
            <div style="display:flex;justify-content: space-between;align-items: center;margin-bottom:15px">
                <el-button-group class="ml-4">
                    <el-button type="primary" :icon="Plus" size="small" @click="showAddReview" />
                </el-button-group>
                <el-input v-model="searchEmail" size="small" class="w-50 m-2" placeholder="Please enter the email"
                    :prefix-icon="Search" style="width:190px" />
            </div>
            <div>
                <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick" style="height:330px">
                    <el-tab-pane label="Associate" name="1">
                        <el-row :gutter="10" class="send-box">
                            <el-col :span="8" v-for="item in reviewerlist" :key="item.id">
                                <el-card shadow="never" class="choice-send">
                                    <el-avatar :src="item.pic" />
                                    <span class="email-text" style="margin-left:10px">{{ item.email }}</span>
                                    <el-checkbox v-model="item.ispush" size="large" class="check"
                                        :disabled="item.ispush === true && item.isaccept != null"
                                        @change="statuschange(item.id)" />
                                    <el-text class="mx-1 status" size="small"
                                        v-if="item.ispush === true && item.isaccept == 0" type="primary">Not
                                        Accessed</el-text>
                                    <el-text class="mx-1 status" size="small"
                                        v-if="item.ispush === true && item.isaccept == 1" type="warning">No
                                        Review</el-text>
                                    <el-text class="mx-1 status" size="small"
                                        v-else-if="item.ispush === true && item.isaccept >= 2" type="success">Review
                                        Added</el-text>
                                </el-card>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="Reviewer's Pool" name="2">
                        <el-row :gutter="10" class="send-box">
                            <el-col :span="8" v-for="item in reviewerlist" :key="item.id">
                                <el-card shadow="never" class="choice-send">
                                    <el-avatar :src="item.pic" />
                                    <span style="font-size:13px;margin-left:10px">{{ item.email }}</span>
                                    <el-checkbox v-model="item.ispush" size="large" class="check"
                                        :disabled="item.ispush === true && item.isaccept != null"
                                        @change="statuschange(item.id)" />
                                    <el-text class="mx-1 status" size="small"
                                        v-if="item.ispush === true && item.isaccept == 0" type="primary">Not
                                        Accessed</el-text>
                                    <el-text class="mx-1 status" size="small"
                                        v-if="item.ispush === true && item.isaccept == 1" type="warning">No
                                        Review</el-text>
                                    <el-text class="mx-1 status" size="small"
                                        v-else-if="item.ispush === true && item.isaccept >= 2" type="success">Review
                                        Added</el-text>
                                </el-card>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <el-row :gutter="10" justify="center" class="pagebox">
                <el-col :span="21" style="display:flex;justify-content: center;margin-top:45px">
                    <el-pagination background layout="prev, pager, next" :current-page="parseInt(assPage.curpage)"
                        :total="parseInt(assPage.total)" :page-size="parseInt(assPage.pagesize)"
                        @currentChange="reviewsPageChange" hide-on-single-page small v-if="activeName == '1'" />
                    <el-pagination background layout="prev, pager, next" :current-page="parseInt(poolPage.curpage)"
                        :total="parseInt(poolPage.total)" :page-size="parseInt(poolPage.pagesize)"
                        @currentChange="poolPageChange" hide-on-single-page small v-if="activeName == '2'" />
                </el-col>
            </el-row>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="pushinfo" type="primary">Invitation for review</el-button><el-button
                        @click="decision" type="primary" v-if="diaPaperId.status != 4">decision-making</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 添加审稿者 -->
        <el-dialog v-model="diaSubreviewerAddShow" title="Add reviewer" width="55%" style="margin-top: 1%;" center>
            <el-form :model="formSubreviewer" label-width="230px" label-position="right" :rules="rules">
                <el-form-item label="Subreviewer's first name:" prop="firstname">
                    <el-input v-model="formSubreviewer.firstname" autocomplete="off" />
                </el-form-item>
                <el-form-item label="Subreviewer's last name:" prop="lastname">
                    <el-input v-model="formSubreviewer.lastname" autocomplete="off" />
                </el-form-item>
                <el-form-item label="Subreviewer's email address:" prop="email">
                    <el-input v-model="formSubreviewer.email" autocomplete="off" @blur="retrievalinfo" />
                </el-form-item>
                <el-form-item name="isAdd">
                    <el-checkbox label="also add this reviewer to the pool" v-model="formSubreviewer.isadd"
                        formSubreviewer />
                </el-form-item>
                <el-divider />
                <el-form-item label="Subject:" name="subject" prop="subject">
                    <el-input v-model="formSubreviewer.subject" autocomplete="off" />
                </el-form-item>
                <el-form-item label="Message:" name="message" prop="message">
                    <el-input v-model="formSubreviewer.message" autocomplete="off" type="textarea" resize="none"
                        :autosize="{ minRows: 4, maxRows: 50 }" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="diaSubreviewerAddShow = false" style="width: 150px;">Cancel</el-button>
                    <el-button type="primary" @click="addReviewer" style="width: 150px;">
                        Confirm
                    </el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 添加消息模板 -->
        <el-dialog v-model="diaMessageAddShow" title="Email template" width="55%" style="margin-top: 1%;" center>
            <el-form :model="formSubreviewer" label-width="230px" label-position="right" :rules="rules">
                <el-form-item label="Subject:" name="subject" prop="subject">
                    <el-input v-model="formSubreviewer.subject" autocomplete="off" />
                </el-form-item>
                <el-form-item label="Message:" name="message" prop="message">
                    <el-input v-model="formSubreviewer.message" autocomplete="off" type="textarea" resize="none"
                        :autosize="{ minRows: 19, maxRows: 50 }" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="diaMessageAddShow = false" style="width: 150px;">Cancel</el-button>
                    <el-button type="primary" @click="okPush" style="width: 150px;">
                        Confirm
                    </el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog v-model="diadownloadZipTip" title="Download Progress" width="30%" center @close="closeRequest">
            <el-progress :percentage="percentage" :color="customColors" />
            <template #footer>
                <span class="dialog-footer">
                    <el-button type="primary" @click="cancelRequest" v-if="percentage != 100">Cancel
                        Download</el-button>
                </span>
            </template>
        </el-dialog>
        
        <!-- Email Management Dialog -->
        <el-dialog v-model="diaEmailManagement" title="Email Management" width="80%" center>
            <div style="margin-bottom: 15px; font-size: 14px; color: #606266;">
                <el-icon><InfoFilled /></el-icon> 
                <span style="margin-left: 5px;">These are all sent email records for the {{ route.query.acronym }} conference</span>
            </div>
            <el-table :data="emailList" style="width: 100%" border height="400px">
                <template #empty>
                    <el-empty description="No Data" />
                </template>
                <el-table-column prop="subject" label="Subject" align="center" />
                <el-table-column prop="toEmail" label="Recipient" align="center" width="200"/>
                <el-table-column prop="toText" label="Content" align="center" />
                <el-table-column prop="sendTime" label="Send Time" align="center" width="200"/>
                <el-table-column label="Status" align="center" width="100">
                    <template #default>
                        <el-icon color="#67C23A" :size="20"><CircleCheckFilled /></el-icon>
                    </template>
                </el-table-column>
            </el-table>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="diaEmailManagement = false" type="primary">Close</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useStore } from 'vuex'
import { useRouter, useRoute } from "vue-router";
import { saveAs } from 'file-saver';
import { ElMessage } from 'element-plus'
import request from "../../network/request"
import checkPermission from "../../utils/checkPermission"
import { View, Document, Refresh, Position, Search, Plus, Message, ArrowLeftBold, CircleCheckFilled, InfoFilled } from '@element-plus/icons-vue'
import axios from 'axios'


const route = useRoute()
const router = useRouter()
const store = useStore()

// 会议投稿论文
const conferencePaperList = ref([])
const sortRule = ref("id asc")
const diadetails = ref(false)
const diaSubreviewerAddShow = ref(false)
const diaMessageAddShow = ref(false)
const searchEmail = ref()
// 对话框所获得的论文pid
const diaPaperId = ref()
// 对话框所获得的论文标题
const diaPaperTitle = ref()
// 对话框所获得的论文自增ID
const diaPaperAutoId = ref()
// 审稿人列表
const reviewerlist = ref([])
// 会议投稿论文列表分页器
const conferencePage = ref({
    curpage: 1,
    pagesize: 10,
    total: 0,
})
// 下载进度值
const percentage = ref(0)
const diadownloadZipTip = ref(false)
const customColors = [
    { color: '#f56c6c', percentage: 20 },
    { color: '#e6a23c', percentage: 40 },
    { color: '#5cb87a', percentage: 60 },
    { color: '#1989fa', percentage: 80 },
    { color: '#6f7ad3', percentage: 100 },
]
const CancelToken = axios.CancelToken;
let source = CancelToken.source();

const diaEmailManagement = ref(false)
const emailList = ref([])

const showAddReview = () => {
    diaSubreviewerAddShow.value = true
    formSubreviewer.value.message = `Dear [*FIRST-NAME*],

I am a PC member of ${route.query.acronym}. Could you please write
a review for me on the following paper submitted to ${route.query.acronym}:

-------------------------------------
  Paper id: ${diaPaperAutoId.value}
  Title: ${diaPaperTitle.value}
-------------------------------------

The instructions on how to answer this review request
can be found at the bottom of this letter.

I need to receive the review by ...

If you cannot review this paper, could you please suggest names and
email addresses of 2-3 possible reviewers?

Best regards,
${store.state.user.firstname} ${store.state.user.lastname} <${store.state.user.email}>
`
    formSubreviewer.value.subject = `${route.query.acronym} submission review request`
}

const formSubreviewer = ref({
    firstname: "",
    lastname: "",
    email: "",
    isadd: false,
    subject: "",
    message: ""
})


// 审稿人列表
const activeName = ref("1")
// 搜索值
const searchValue = ref("")

onMounted(() => {
    // 获取会议投稿论文列表
    getConferencePaperList()
})

// 检索用户信息
const retrievalinfo = () => {
    formSubreviewer.value.email = formSubreviewer.value.email.trim()
    request.get(`/user/author?email=${formSubreviewer.value.email}`).then((res) => {
        if (res.code == 200) {
            let data = res.data
            formSubreviewer.value.firstname = data.firstname
            formSubreviewer.value.lastname = data.lastname
        }
    })
}


// 添加审稿人
const addReviewer = () => {
    request.post(`/reviewer`, {
        "cid": route.query.cid,
        "pid": diaPaperId.value,
        "autoid": diaPaperAutoId.value,
        "email": formSubreviewer.value.email,
        "subject": formSubreviewer.value.subject,
        "message": formSubreviewer.value.message.replace("[*FIRST-NAME*]", formSubreviewer.value.firstname),
        "isadd": formSubreviewer.value.isadd
    }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: `added successfully`,
                type: 'success',
            })
            diaSubreviewerAddShow.value = false
        }
        else {
            ElMessage({
                message: res.msg,
                type: 'warning',
            })
        }
    })
}

// 表单效验规则
const rules = ref({
    firstname: [{ required: true, message: 'Please input first name', trigger: 'blur' }],
    lastname: [{ required: true, message: 'Please input last name', trigger: 'blur' }],
    firstname: [{ required: true, message: 'Please input name', trigger: 'blur' }],
    email: [{ required: true, message: 'Please input email', trigger: 'blur' }],
    isAdd: [{ required: true, message: 'Please choice:', trigger: 'change' }],
    subject: [{ required: true, message: 'Please input subject:', trigger: 'blur' }],
    message: [{ required: true, message: 'Please input message', trigger: 'blur' }]
})



let isFetching = ref(false);
// 获取会议投稿论文列表
function getConferencePaperList() { 
    request.get(`/conference/paperlist?pagenum=${conferencePage.value.curpage}&pagesize=${conferencePage.value.pagesize}&cid=${route.query.cid}&sortRule=${sortRule.value}&keyword=${searchValue.value}`).then((res) => {
        conferencePaperList.value = []
        let datalist = res.data.list;
        conferencePage.value.total = res.data.total;
        datalist.forEach((item) => {
            let authornamelist = []
            item.authorList.forEach((author) => {
                authornamelist.push(author.firstname + " " + author.lastname)
            })
            let authornames = authornamelist.join(",")
            let title = item.title
            let status = ""
            if (item.isTermination == 1) {
                status = "rejected manuscript"
            }
            else if (item.status == 0) {
                status = "to be modified"
            }
            else if (item.status == 1) {
                status = "to be pushed"
            }
            else if (item.status == 2) {
                status = "to be pushed"
            }
            else if (item.status == 3) {
                status = "pending decision"
            }
            else if (item.status == 4) {
                status = "has been accepted"
            }
            // 添加作者单位属性到item对象中
            item.affiliation = item.authorList.map(author => author.affiliation || "")
            conferencePaperList.value.push({ 
                id: item.id, 
                pid: item.pid, 
                authors: authornames, 
                title: title, 
                status, 
                paperfile: item.paperfile, 
                isTermination: item.isTermination, 
                updatetime: item.updatetime, 
                autoid: item.autoid,
                affiliation: item.affiliation // 将作者单位信息添加到列表项中
            })
        })
    })
}


// 推送论文给审稿人
const pushinfo = () => {
    diaMessageAddShow.value = true
    formSubreviewer.value.message = `Dear [*FIRST-NAME*],

I am a PC member of ${route.query.acronym}. Could you please write
a review for me on the following paper submitted to ${route.query.acronym}:

-------------------------------------
  Paper id: ${diaPaperAutoId.value}
  Title: ${diaPaperTitle.value}
-------------------------------------

The instructions on how to answer this review request
can be found at the bottom of this letter.

I need to receive the review by ...

If you cannot review this paper, could you please suggest names and
email addresses of 2-3 possible reviewers?

Best regards,
${store.state.user.firstname} ${store.state.user.lastname} <${store.state.user.email}>
`
    formSubreviewer.value.subject = `${route.query.acronym} submission review request`


}

// 推送审稿人信息
const okPush = () => {
    let data = []
    reviewerlist.value.forEach((item) => {
        if (item.isaccept == null && item.ispush == true) {
            item.message = formSubreviewer.value.message.replace("[*FIRST-NAME*]", item.firstname)
            item.subject = formSubreviewer.value.subject
            item.cid = route.query.cid
            item.pid = diaPaperId.value
            data.push(item)
        }
    })
    if (data.length != 0) {
        request.post("/paper/pushpaper", {
            reviewerlist: JSON.stringify(data)
        }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
            if (res.code == 200) {
                ElMessage({
                    message: `${data.length} reviewers have been pushed`,
                    type: 'success',
                })
                diadetails.value = false
                diaMessageAddShow.value = false
                getConferencePaperList()
            }
            else {
                ElMessage({
                    message: res.msg,
                    type: 'warning',
                })
            }
        })
    }
    else {
        ElMessage({
            message: `0 reviewers have been pushed`,
            type: 'success',
        })
        diaMessageAddShow.value = false
    }

}

// 直接进入决策阶段
const decision = (index, row) => {
    request.post("/paper/decision", {
        pid: diaPaperId.value,
        choice: 0
    }, {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'entering the decision-making stage',
                type: 'success',
            })
            diadetails.value = false
        }
    })
}

// 查看论文详细信息
const look = (index, row) => {
    window.open(`#/common/detailpaper?pid=${row.pid}&role=3&acronym=${route.query.acronym}`, '_blank');
}



// Associate分页器
const assPage = ref({
    curpage: 1,
    pagesize: 9,
    total: 0,
})

//Associate分页器事件，修改分页
const reviewsPageChange = (curpage) => {
    assPage.value.curpage = curpage;
    assReviews()
}

// Associate审稿人信息
function assReviews() {
    request.get(`/paper/pushlist?pagenum=${assPage.value.curpage}&pagesize=${assPage.value.pagesize}&cid=${route.query.cid}&pid=${diaPaperId.value}&status=0`).then((res) => {
        reviewerlist.value = res.data.list
        assPage.value.total = res.data.total
        reviewerlist.value.forEach((item) => {
            if (item.isaccept == null) {
                item.ispush = false
            }
        })
    })
}

// pool分页器
const poolPage = ref({
    curpage: 1,
    pagesize: 9,
    total: 0,
})

//pool分页器事件，修改分页
const poolPageChange = (curpage) => {
    poolPage.value.curpage = curpage;
    poolReviews()
}

// Pool审稿人信息
function poolReviews() {
    request.get(`/paper/pushlist?pagenum=${poolPage.value.curpage}&pagesize=${poolPage.value.pagesize}&cid=${route.query.cid}&pid=${diaPaperId.value}&status=1`).then((res) => {
        reviewerlist.value = res.data.list
        poolPage.value.total = res.data.total
        reviewerlist.value.forEach((item) => {
            if (item.isaccept == null) {
                item.ispush = false
            }
        })
    })
}

// 推荐审稿人信息
function isrecommendReviews() {
    request.get(`/paper/pushlist?pagenum=1&pagesize=10&pid=${diaPaperId.value}&isrecommend=1`).then((res) => {
        reviewerlist.value = res.data.list
        reviewerlist.value.forEach((item) => {
            if (item.isaccept == null) {
                item.ispush = false
            }
        })
    })
}


// 触发发送事件，拿到审稿人列表，给对话框渲染
const send = (index, row) => {
    diadetails.value = true
    diaPaperId.value = row.pid
    diaPaperAutoId.value = row.autoid
    diaPaperTitle.value = row.title
    activeName.value = "1"
    assReviews()
}

// 切换审稿人列表（全部、历史、推荐）
const handleClick = (payload) => {
    activeName.value = payload.props.name
    if (activeName.value == "1") {
        assReviews()
    }
    else if (activeName.value == "2") {
        poolReviews()
    }
    else {
        isrecommendReviews()
    }

}

// 修改复选框选中审稿人的状态
const statuschange = (id) => {
    reviewerlist.value.forEach((item) => {
        if (item.id == id) {
            if (item.checked == false) {
                item.status = 0
            }
            else if (item.status < 2 && item.checked == true) {
                item.status = 1
            }
        }
    })
}


// 修改页数
const changePage = (index) => {
    conferencePage.value.curpage = index
    getConferencePaperList()
}

// 获取排序列和排序规则，交由后端负责排序
const sortTable = (payload) => {
    if (payload.column.order == "ascending") {
        let ordercol = payload.column.label.toLowerCase() == 'id' ? 'autoid' : payload.column.label.toLowerCase()
        sortRule.value = ordercol + " " + payload.column.order.substring(0, 3)
        getConferencePaperList()
    }
    else if (payload.column.order == "descending") {
        let ordercol = payload.column.label.toLowerCase() == 'id' ? 'autoid' : payload.column.label.toLowerCase()
        sortRule.value = ordercol + " " + payload.column.order.substring(0, 4)
        getConferencePaperList()
    }
    else {
        sortRule.value = "createtime desc"
        getConferencePaperList()
    }

}

// 搜索值改变，修改后端
const changeSearchValue = (payload) => {
    setTimeout(() => {
        getConferencePaperList()
    }, 500);
}

//下载论文PDF
const download = (index, payload) => {
    let acronym = route.query.acronym.split(" ").join("_")
    let autoid = payload.autoid
    saveAs(payload.paperfile, `${acronym}_paper_${autoid}.pdf`)
}

// 路由跳转到删除的页面
const paperDelete = () => {
    router.push(`/common/paperdelete?cid=${route.query.cid}&acronym=${route.query.acronym}`)
}

// 路由跳转到发送邮件的页面
const authoremail = () => {
    router.push(`/common/authoremail?cid=${route.query.cid}&acronym=${route.query.acronym}`)
}

// 路由跳转到会议详细页
const confdesc = () => {
    let sublink = route.query.acronym.replace("_", "").replace(" ", "").toLowerCase()
    router.push(`/common/submitpaper?conf=${sublink}`)
}

// 录用跳转到论文状态页
const paperStatus = () => {
    router.push(`/common/paperstatus?cid=${route.query.cid}&acronym=${route.query.acronym}`)
}


// OutFile（点击导出按钮触发事件,进行论文集导出）
const outPaper = () => {
    percentage.value = 0
    source = CancelToken.source()
    diadownloadZipTip.value = true
    request.post(`/paper/download`, { cid: route.query.cid }, {
        responseType: 'blob', "Cache-Control": "no-cache",
        onDownloadProgress: (e) => {
            percentage.value = parseFloat((e.progress * 100).toFixed(1))
        },
        cancelToken: source.token,
        timeout: 1000 * 60 * 120
    }).then((res) => {
        let blob = new Blob([res], { type: 'type: "application/zip' })
        let objectUrl = URL.createObjectURL(blob) // 创建URL
        const link = document.createElement('a')
        link.href = objectUrl
        // 定义文件名
        link.download = `${route.query.acronym}_submissions.zip`
        // 下载文件
        link.click()
        ElMessage({
            message: `successfully exported the collection of papers`,
            type: 'success',
        })
        // 释放内存
        URL.revokeObjectURL(objectUrl);
    }).catch((error) => {

    });
}

// 取消下载请求的函数
const closeRequest = () => {
    diadownloadZipTip.value = false
    source.cancel('user cancel');
}

// 取消下载请求的函数
const cancelRequest = () => {
    ElMessage({
        message: `Cancel Download`,
        type: 'warning',
    })
    diadownloadZipTip.value = false
    source.cancel('user cancel');
}

// 邮件管理功能
const emailManagement = () => {
    diaEmailManagement.value = true
    getEmailList()
}

// 获取邮件列表
const getEmailList = () => {
    request.get(`/conference/email?cid=${route.query.cid}`).then((res) => {
        if (res.code == 200) {
            emailList.value = res.data.reverse()
        } else {
            ElMessage({
                message: res.msg,
                type: 'warning',
            })
        }
    })
}

</script>


<style lang="scss">
.viewpaper-box {
    position: absolute;
    top: 100px;
    left: 50px;
    right: 50px;
    bottom: 20px;

    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

    .send-box {
        .el-col {
            margin-bottom: 10px;
        }

        .choice-send {
            position: relative;

            .el-avatar {
                width: 46px;
                height: 46px;
            }

            .email-text {
                font-size: 13px;
            }

            .el-card__body {
                display: flex;
                align-items: center;
            }

            .check {
                position: absolute;
                top: -1px;
                right: 10px;
            }

            .status {
                position: absolute;
                bottom: 5px;
                right: 10px;
            }

        }
    }

    .page-tools {
        display: flex;
        justify-content: center;
        margin-top: 40px;
    }

    .tools-box {
        display: flex;
        justify-content: space-between;
    }

    .click-tips {
        font-size: 13px;

        .text-line {
            border-bottom: 1px solid #88b5cb61;
            display: inline-block;
            margin-bottom: 20px;
            padding-bottom: 5px;
        }

        div {
            margin-bottom: 10px;
        }
    }

    .tb-box {
        .author-text {
            font-size: 13px;
        }

        .title-text {
            font-size: 13px;
        }
    }

}
</style>